import { render, staticRenderFns } from "./ApiDescription.vue?vue&type=template&id=46efe747&"
import script from "./ApiDescription.vue?vue&type=script&lang=js&"
export * from "./ApiDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports